import VueRouter from 'vue-router'
import Vue from 'vue'
import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import AboutLeft from '@/views/About-left.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'About',
    component: About,
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about-left',
    name: 'about-left',
    component: AboutLeft,
  },
  {
    // 排行榜
    path: '/ranking',
    name: 'Ranking',
    component: () => import('@/views/RankingPage.vue'),
  },
  {
    path: '/jiuba/top5',
    name: 'top5',
    component: () => import('@/views/jiubaRating/NationalTopFive/index.vue'),
  },
  {
    path: '/jiuba/top5/team',
    name: 'top5Team',
    component: () => import('@/views/jiubaRating/NationalTopFive/team.vue'),
  },
  {
    path: '/jiuba/round-one',
    name: 'roundOne',
    component: () => import('@/views/jiubaRating/round-one.vue'),
  },
  {
    path: '/jiuba/round-two',
    name: 'roundTwo',
    component: () => import('@/views/jiubaRating/round-two.vue'),
  },
  {
    path: '/jiuba/round-three',
    name: 'roundThree',
    component: () => import('@/views/jiubaRating/round-three.vue'),
  },
  {
    path: '/jiuba/round-four',
    name: 'roundFour',
    component: () => import('@/views/jiubaRating/round-four.vue'),
  },
  {
    path: '/jiuba/round-five',
    name: 'roundFive',
    component: () => import('@/views/jiubaRating/round-five.vue'),
  },
  {
    path: '/bar-chart',
    name: 'barChart',
    component: () => import('@/views/bar-chart.vue'),
  },
  {
    path: '/vs-duel',
    name: 'vsDuel',
    component: () => import('@/views/vs-duel.vue'),
  },
  {
    path: '/top8',
    name: 'Top8',
    component: () => import('@/views/top8.vue'),
  },
  {
    path: '/nine-fourteen',
    name: 'nineFourteen',
    component: () => import('@/views/nine-fourteen.vue'),
  },
  {
    path: '/wjwl/index',
    name: 'wjwlIndex',
    component: () => import('@/views/wjwl/index.vue'),
  },
  //大众评委和专业评委 在一个页面显示
  {
    path: '/bestProgram/index',
    name: 'bestProgram',
    component: () => import('@/views/bestProgram/index.vue'),
  },
  // 页面删除
  // {
  //   path:'/wjwl/voting-end',
  //   name:'votingEnd',
  //   component:()=>import('@/views/wjwl/voting-end.vue')
  // },
  // {
  //   path:'/wjwl/judges-score',
  //   name:'JudgesScore',
  //   component:()=>import('@/views/wjwl/judges-score.vue')
  // },
  {
    path: '/wjwl/total-money',
    name: 'TotalMoney',
    component: () => import('@/views/wjwl/total-money.vue'),
  },
  {
    path: '/wjwl/audience-judging',
    name: 'AudienceJudging',
    component: () => import('@/views/wjwl/audience-judging.vue'),
  },
  {
    path: '/wjwl/rank-one',
    name: 'rankOne',
    component: () => import('@/views/wjwl/rank-one.vue'),
  },
  {
    path: '/wjwl/rank-two',
    name: 'rankTwo',
    component: () => import('@/views/wjwl/rank-two.vue'),
  },
  {
    path: '/wjwl/rank-three',
    name: 'rankThree',
    component: () => import('@/views/wjwl/rank-three.vue'),
  },
  {
    path: '/wjwl/mvp-students',
    name: 'mvpStudents',
    component: () => import('@/views/wjwl/mvp-students.vue'),
  },
  {
    path: '/wjwl/volvo-bar',
    name: 'volvoBar',
    component: () => import('@/views/wjwl/volvo-bar.vue'),
  },
  {
    path: '/dangmushangqian/index',
    name: 'dangmushangqian',
    component: () => import('@/views/dangmushangqian/index.vue'),
  },
  {
    path: '/dangmushangqian/test',
    name: 'dangmushangqiantest',
    component: () => import('@/views/dangmushangqian/test.vue'),
  },
  {
    path: '/bapin/index',
    name: 'bapin',
    component: () => import('@/views/bapin/index.vue'),
  },
  {
    path: '/livemark', //大屏幕样式 参评人主视觉
    name: 'livemark',
    component: () => import('@/views/livemark'),
  },
  {
    path: '/dati/index',
    name: 'datiIndex',
    component: () => import('@/views/dati/index.vue'),
  },
  {
    path: '/dati/answer',
    name: 'datiAnswer',
    component: () => import('@/views/dati/answer.vue'),
  },
  {
    path: '/dati/answer-list',
    name: 'datiAnswerList',
    component: () => import('@/views/dati/answer-list.vue'),
  },
  {
    path: '/kongmingdeng/index',
    name: 'kongmingdengIndex',
    component: () => import('@/views/kongmingdeng/index.vue'),
  },
  {
    path: '/zhongqiuvote/index',
    name: 'zhongqiuvoteIndex',
    component: () => import('@/views/zhongqiuvote/index.vue'),
  },
  {
    path: '/zhongqiuvote/totle',
    name: 'zhongqiuvoteTotle',
    component: () => import('@/views/zhongqiuvote/totle.vue'),
  },
  {
    path: '/zhongqiuvote/home',
    name: 'zhongqiuvoteHome',
    component: () => import('@/views/zhongqiuvote/home.vue'),
  },
  {
    path: '/zhejiangyinyue/index',
    name: 'zhejiangyinyueIndex',
    component: () => import('@/views/zhejiangyinyue/index.vue'),
  },
  {
    path: '/zhejiangyinyue/details',
    name: 'zhejiangyinyueDetails',
    component: () => import('@/views/zhejiangyinyue/details.vue'),
  },
  {
    path: '/zhejiangyinyue/list',
    name: 'zhejiangyinyueList',
    component: () => import('@/views/zhejiangyinyue/list.vue'),
  },
  {
    path: '/zhejiangyinyue/excel-export',
    name: 'zhejiangyinyueExcelExport',
    component: () => import('@/views/zhejiangyinyue/excel-export.vue'),
  },
  {
    path: '/zhejiangyinyue/finals-score',
    name: 'zhejiangyinyueFinalsScore',
    component: () => import('@/views/zhejiangyinyue/finals-score.vue'),
  },
  {
    path: '/zhejiangyinyue/finals-result',
    name: 'zhejiangyinyueFinalsResult',
    component: () => import('@/views/zhejiangyinyue/finals-result.vue'),
  },
  {
    path: '/zhuoyueqihangrengou/thirteen-rengou',
    name: 'thirteenRengou',
    component: () => import('@/views/zhuoyueqihangrengou/thirteen-rengou.vue'),
  },
  {
    path: '/zhuoyueqihangrengou/thirteen-result',
    name: 'thirteenResult',
    component: () => import('@/views/zhuoyueqihangrengou/thirteen-result.vue'),
  },
  {
    path: '/zhuoyueqihangrengou/twenty-five-rengou',
    name: 'twentyFiveRengou',
    component: () =>
      import('@/views/zhuoyueqihangrengou/twenty-five-rengou.vue'),
  },
  {
    path: '/zhuoyueqihangrengou/twenty-five-result',
    name: 'twentyFiveResult',
    component: () =>
      import('@/views/zhuoyueqihangrengou/twenty-five-result.vue'),
  },
  {
    path: '/zhuoyueqihangrengou/thirty-seven-rengou',
    name: 'thirtySevenRengou',
    component: () =>
      import('@/views/zhuoyueqihangrengou/thirty-seven-rengou.vue'),
  },
  {
    path: '/zhuoyueqihangrengou/thirty-seven-result',
    name: 'thirtySevenResult',
    component: () =>
      import('@/views/zhuoyueqihangrengou/thirty-seven-result.vue'),
  },
  {
    path: '/yanhua/index',
    name: 'yanhuaIndex',
    component: () => import('@/views/yanhua/index.vue'),
    meta: {
      title: '弹幕烟花',
    },
  },
  {
    path: '/yanhua/test',
    name: 'yanhuatest',
    component: () => import('@/views/yanhua/test.vue'),
  },
  {
    path: '/haerbing/index',
    name: 'haerbingIndex',
    component: () => import('@/views/haerbing/index.vue'),
    meta: {
      title: '冰雪大世界弹幕烟花',
    },
  },
  //付费弹幕
  {
    path: '/dengpainew/index',
    name: 'dengpainewIndex',
    component: () => import('@/views/dengpainew/index.vue'),
    meta: {
      title: '灯牌弹幕烟花',
    },
  },
  //俄罗斯方块项目
  {
    path: '/tanchise/index',
    name: 'tanchise',
    component: () => import('@/views/tanchise/index.vue'),
    meta: {
      title: '俄罗斯方块',
    },
  },
  {
    path: '/livemarkuserone', //宁德市中华经典诵读大赛（小学生组）
    name: 'livemarkuserone',
    component: () => import('@/views/livemark/livemarkuserone'),
    meta: {
      title: '宁德市中华经典诵读大赛（小学生组）',
    },
  },
  {
    path: '/liveBarrage',
    name: 'liveBarrage',
    component: () => import('@/views/liveBarrage/index.vue'),
    meta: {
      title: '大屏上墙',
    },
  },
  // 大屏辩论赛
  {
    path: '/debateCast',
    name: 'debateCast',
    component: () => import('@/views/debateCast/index.vue'),
    meta: {
      title: '大屏辩论赛',
    }
  },
  // 大屏营收展示
  {
    path: '/revenue-dashboard',
    name: 'revenue',
    component: () => import('@/views/revenue/index.vue'),
    meta: {
      title: '大屏营收展示',
    }
  },
  // 答题
  {
    path: '/quiz',
    name: 'quiz',
    component: () => import('@/views/quiz/index.vue'),
    meta: {
      title: '考试',
    },
  },
  // 20250524评委评分
  {
    path: '/judge-scoring-dashboard',
    name: 'judgeScoring',
    component: () => import('@/views/judgeScoring/index.vue'),
    meta: {
      title: '评委评分',
    },
  }
  ,
  {
    path: '/livemark_user/ranking',
    name: 'livemarkUserRanking',
    component: () => import('@/views/livemark_user/ranking.vue'),
    meta: {
      title: '排行榜',
    },
  },
   {
    path: '/livemark_user/ranking_moren',
    name: 'livemarkUserRankingMoren',
    component: () => import('@/views/livemark_user/ranking_moren.vue'),
    meta: {
      title: '默认排行榜',
    },
  },
  {
    path: '/book-quotes-match',
    name: 'bookQuotesMatch',
    component: () => import('@/views/bookQuotesMatch/index.vue'),
    meta: {
      title: '书语对对碰',
    },
  },
  {
    path: '/score-screen/index',
    name: 'scoreScreen',
    component: () => import('@/views/scoreScreen/index.vue'),
    meta: {
      title: '大屏评分展示',
    },
  },
  {
    path: '/score-screen/rank-list',
    name: 'scoreScreenRankList',
    component: () => import('@/views/scoreScreen/rankList.vue'),
    meta: {
      title: '大屏排行榜',
    },
  },
  {
    path: '/barrage-screen',
    name: 'barrageScreen',
    component: () => import('@/views/barrageScreen/index.vue'),
    meta: {
      title: '弹幕大屏',
    },
  },
  {
    path: '/quizscreen',
    component: () => import('@/views/quizscreen/layout/FullScreen.vue'),
    children: [
      {
        path: '',
        redirect: 'ready'
      },
      {
        path: 'ready', // 准备页
        name: 'quizReady',
        component: () => import('@/views/quizscreen/pages/Ready/index.vue'),
        meta: { title: '准备答题' }
      },
      {
        path: 'play',  // 答题页（含汇总和作答）
        name: 'quizPlay',
        component: () => import('@/views/quizscreen/pages/Play/index.vue'),
        meta: { title: '正在答题' }
      }
    ],
  },
  {
    path: '/music-screen',
    component: () => import('@/views/musicscreen/index.vue'),
    children: [
      { path: 'performer', component: () => import('@/views/musicscreen/screens/PerformerScore.vue') },
      // { path: 'round', component: () => import('@/views/musicscreen/screens/RoundScore.vue') },
      // { path: 'program-rank', component: () => import('@/views/musicscreen/screens/ProgramRank.vue') },
      // { path: 'actor-rank', component: () => import('@/views/musicscreen/screens/ActorCompositeRank.vue') },
      { path: 'top3', component: () => import('@/views/musicscreen/screens/TopThreeComposite.vue') },
      { path: 'program-mix', component: () => import('@/views/musicscreen/screens/ProgramMix.vue') },
      { path: 'final-rank', component: () => import('@/views/musicscreen/screens/FinalAllRank.vue') },
    ]
  },
  {
      path: '/intention-screen',
      name: 'intentionScreen',
      component: () => import('@/views/intentionScreen/index.vue'),
      meta: { title: '大屏展示' }
  },
  {
      path: '/intention-screen-2026',
      name: 'intentionScreen2026',
      component: () => import('@/views/intentionScreen2026/index.vue'),
      meta: { title: '活动' }
  },
  {
      path: '/contest-display',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'score/marker',
          component: () => import('@/views/contest-display/score/index.vue'),
          meta: { design: { w: 1920, h: 1080 }, theme: 'marker' }
        },
        {
          path: 'score/enterprise',
          component: () => import('@/views/contest-display/score/index.vue'),
          meta: { design: { w: 1920, h: 1080 }, theme: 'enterprise' }
        },
        {
          path: 'timer/marker',
          component: () => import('@/views/contest-display/timer/index.vue'),
          meta: { design: { w: 1920, h: 1080 }, theme: 'marker' }
        },
        {
          path: 'timer/enterprise',
          component: () => import('@/views/contest-display/timer/index.vue'),
          meta: { design: { w: 1920, h: 1080 }, theme: 'enterprise' }
        },
        {
          path: '',
          redirect: 'score/marker'
        }
      ]
  },
  {
    path: '/august-judge-panel/:matchId',
    component: () => import('@/views/august-judge-panel/index.vue'),
    children: [
      {
        path: 'judges-score',
        name: 'AugustJudgesScore',
        component: () => import('@/views/august-judge-panel/pages/JudgesScore.vue'),
        props: true
      },
      {
        path: 'round-summary',
        name: 'AugustRoundSummary',
        component: () => import('@/views/august-judge-panel/pages/RoundSummary.vue'),
        props: true
      },
      {
        path: 'total-score',
        name: 'AugustTotalScore',
        component: () => import('@/views/august-judge-panel/pages/TotalScore.vue'),
        props: true
      },
      {
        path: 'leaderboard',
        name: 'AugustLeaderboard',
        component: () => import('@/views/august-judge-panel/pages/Leaderboard.vue'),
        props: true
      },
      {
        path: '',
        redirect: { name: 'AugustJudgesScore' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
